export const Decimal = (data: number) => {
	return Math.round((data + Number.EPSILON) * 100) / 100
}
